import { useMemo } from 'react';
import { registerQuery, useQuery } from 'data-fetching-client';
import { getFrameworkDataSchemasClient } from 'framework-data-schema-resolvers';
const GET_PIPELINE_PROPERTY = 'vizcorePipelinePropertyName';
const getPipelinePropertyQuery = registerQuery({
  fieldName: GET_PIPELINE_PROPERTY,
  args: ['objectTypeId'],
  async fetcher({
    objectTypeId
  }) {
    const objectTypeDefs = await getFrameworkDataSchemasClient().then(client => client.frameworkTypes.getObjects());
    const objectTypeDef = objectTypeDefs.find(def => def.objectTypeId === objectTypeId);
    return objectTypeDef === null || objectTypeDef === void 0 ? void 0 : objectTypeDef.pipelinePropertyName;
  }
});

/**
 * Hook to fetch the pipeline property name for the current object type.
 *
 * Uses the framework-data-schema-resolvers to fetch object type definitions
 * and extract the appropriate pipeline property name.
 *
 * @param draftContext The draft context containing objectTypeId
 * @returns Object containing pipelinePropertyName, loading state, and error
 */
export function usePipelineProperty(objectTypeId) {
  const {
    loading,
    error,
    data
  } = useQuery(getPipelinePropertyQuery, {
    variables: {
      objectTypeId
    }
  });
  return useMemo(() => ({
    data: data === null || data === void 0 ? void 0 : data[GET_PIPELINE_PROPERTY],
    loading,
    error
  }), [data, loading, error]);
}